export const storage = {
    // Set storage with expiration time
    setItem(key, value, expireHours = 24) {
        const now = new Date().getTime();
        const expireTime = now + expireHours * 60 * 60 * 1000;
        const item = {
            value: value,
            expireTime: expireTime
        };
        localStorage.setItem(key, JSON.stringify(item));
    },

    // Get storage value, automatically check expiration time
    getItem(key) {
        const itemStr = localStorage.getItem(key);
        if (!itemStr) {
            return null;
        }

        try {
            const item = JSON.parse(itemStr);
            const now = new Date().getTime();

            // Check if expired
            if (now > item.expireTime) {
                localStorage.removeItem(key);
                return null;
            }

            return item.value;
        } catch (e) {
            // If parsing fails, it may be old data format, return directly
            return itemStr;
        }
    },

    // Delete storage
    removeItem(key) {
        localStorage.removeItem(key);
    },

    // Check if expired
    isExpired(key) {
        const itemStr = localStorage.getItem(key);
        if (!itemStr) {
            return true;
        }

        try {
            const item = JSON.parse(itemStr);
            const now = new Date().getTime();
            return now > item.expireTime;
        } catch (e) {
            return false;
        }
    }
};